export default "__VITE_ASSET__CJEH$D5O__"